import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class JackingV2FileDownloadService {

  public downloadHttpBlobResponse(resp: HttpResponse<Blob>, fallbackFilename: string) {
    const file = resp.body;
    if (!file) { return; }

    const filename = this.getFilenameFromHeaders(resp) ?? fallbackFilename;
    this.downloadBlob(file, filename);
  }

  private getFilenameFromHeaders(resp: HttpResponse<Blob>): string | null {
    const cd = resp.headers.get('content-disposition');
    if (!cd) { return null; }

    const match = /filename\*?=(?:UTF-8''|")?([^\";]+)"?/i.exec(cd);
    if (!match?.[1]) { return null; }

    try {
      return decodeURIComponent(match[1]);
    } catch {
      return match[1];
    }
  }

  private downloadBlob(file: Blob, filename: string) {
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = filename;
    link.click();

    setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
  }
}



// WEBPACK FOOTER //
// ./src/services/jacking-v2/jacking-v2-file-download.service.ts